var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6 col-xl row"},[_c('h1',[_vm._v(" "+_vm._s(_vm.is_loading)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }